import {apiRequest} from "../../../utils/AxiosHelper";
import {API_PARAMS} from "../../../constants/constants";
import APIs from "../../../modules/settings/APIs";
import {useAppSelector} from "../../../hooks/hooks";
import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {Area} from "../../../types";

interface AreaParams {
  node?: string;
  depth?: number;
}

const fetchAreas = async (params: AreaParams): Promise<Area[]> => {
  const response = await apiRequest.get(APIs.parameters.common.area.list, {
    params: {
      node: params.node || API_PARAMS.ROOT,
      depth: params.depth || API_PARAMS.ZERO,
    }
  });

  return response.data.children.children || [];
};

export const useArea = (params: AreaParams = {}, queryOptions?: Partial<UseQueryOptions<Area[], Error>>) => {
  const {isAuthenticated, token} = useAppSelector((state) => state.session);

  return useQuery({
    queryKey: ['areas', params],
    queryFn: () => fetchAreas(params),
    staleTime: 5 * 60 * 1000,
    retry: 2,
    enabled: isAuthenticated && !!token,
    ...queryOptions
  });
};
